/**
 * Maps app.band-space.com discovery URLs to the matching band-space.com
 * marketing SEO pages so crawlers consolidate duplicate content.
 *
 * App slugs use underscores; marketing /warszawa/sale-prob/ slugs use hyphens.
 */

export const MARKETING_SITE_ORIGIN = 'https://band-space.com';
export const WARSAW_CITY_SLUG = 'warszawa';
export const WARSAW_SALE_PROB_PATH = '/warszawa/sale-prob/';

/** Convert an app URL slug (underscores) to the marketing SEO slug (hyphens). */
export function appSlugToMarketingSlug(appSlug: string): string {
  return appSlug.trim().toLowerCase().replace(/_/g, '-').replace(/-+/g, '-').replace(/^-|-$/g, '');
}

export function isWarsawCitySlug(citySlug: string | null | undefined): boolean {
  if (!citySlug) return false;
  return citySlug.trim().toLowerCase().replace(/_/g, '') === WARSAW_CITY_SLUG;
}

export function marketingWarsawListingUrl(): string {
  return `${MARKETING_SITE_ORIGIN}${WARSAW_SALE_PROB_PATH}`;
}

export function marketingWarsawVenueUrl(appSpaceSlug: string): string {
  const slug = appSlugToMarketingSlug(appSpaceSlug);
  return `${MARKETING_SITE_ORIGIN}${WARSAW_SALE_PROB_PATH}${slug}/`;
}

/**
 * Canonical for Warsaw app search/venue paths.
 * Returns undefined for non-Warsaw cities (no matching marketing page yet).
 */
export function resolveMarketingCanonicalForAppPath(
  citySlug?: string | null,
  spaceSlug?: string | null,
): string | undefined {
  if (!isWarsawCitySlug(citySlug)) {
    return undefined;
  }
  if (spaceSlug && spaceSlug.trim()) {
    return marketingWarsawVenueUrl(spaceSlug);
  }
  return marketingWarsawListingUrl();
}
